import { render, staticRenderFns } from "./SynapseColumnMangeDialog.vue?vue&type=template&id=f126f644"
import script from "./SynapseColumnMangeDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./SynapseColumnMangeDialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SynapseColumnMangeDialog.vue?vue&type=style&index=0&id=f126f644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports